import { render, staticRenderFns } from "./PublicDisplaySlide.vue?vue&type=template&id=33d8781e&scoped=true"
import script from "./PublicDisplaySlide.vue?vue&type=script&lang=js"
export * from "./PublicDisplaySlide.vue?vue&type=script&lang=js"
import style0 from "./PublicDisplaySlide.vue?vue&type=style&index=0&id=33d8781e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d8781e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33d8781e')) {
      api.createRecord('33d8781e', component.options)
    } else {
      api.reload('33d8781e', component.options)
    }
    module.hot.accept("./PublicDisplaySlide.vue?vue&type=template&id=33d8781e&scoped=true", function () {
      api.rerender('33d8781e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PublicDisplay/PublicDisplaySlide.vue"
export default component.exports